module.exports = __webpack_public_path__ + "img/ji-3.a607db1a.png";